export default "__VITE_ASSET__BA$qtOS2__"